import ABCyaPhaser from '@abcya/abcya_phaser';
import Phaser from 'phaser';
import UIAssetKeys from '../UIAssetKeys';
import Forces from '../math/Forces';

export default class Caboose extends Phaser.GameObjects.Image {
  /**
   * 
   * @param {Phaser.Scene} scene 
   */
  constructor(scene) {
    super(scene, 0, 0, ABCyaPhaser.Images.DEFAULT_ATLAS, UIAssetKeys._Santa_Wave);

    this.rope = null;

    this.gravity = 200;
    this.kDamping = 15;
    this.kSpring = 300;
    this.springLength = 20;
    this.mass = 1;

    this.pos = new Phaser.Math.Vector2();
    this.vel = new Phaser.Math.Vector2();

    this.x = this.pos.x;
    this.y = this.pos.y;

    this.displPrev = new Phaser.Math.Vector2();
    this.displNext = new Phaser.Math.Vector2();
    this.extensionPrev = new Phaser.Math.Vector2();
    this.extensionNext = new Phaser.Math.Vector2();
    this.restoringPrev = new Phaser.Math.Vector2();
    this.restoringNext = new Phaser.Math.Vector2();
    this.unitNext = new Phaser.Math.Vector2();
    this.unitPrev = new Phaser.Math.Vector2();

    this.dampingForce = new Phaser.Math.Vector2();
    this.gravityForce = new Phaser.Math.Vector2();
    Forces.constantGravity(this.mass, this.gravity, this.gravityForce);
    this.totalForce = new Phaser.Math.Vector2();
  }

  calcForce (centerNext, centerPrev) {
    Forces.damping(this.kDamping, this.vel, this.dampingForce);
    this.displPrev.set(this.pos.x, this.pos.y);
    this.displPrev.subtract(centerPrev);
    this.displNext.set(this.pos.x, this.pos.y);
    this.displNext.subtract(centerNext);

    // extension
    this.extensionPrev.set(this.displPrev.x, this.displPrev.y);
    Forces.unit(this.displPrev, this.unitPrev);
    this.unitPrev.multiply({ x: this.springLength, y: this.springLength });
    this.extensionPrev.subtract(this.unitPrev);

    this.extensionNext.set(this.displNext.x, this.displNext.y);
    Forces.unit(this.displNext, this.unitNext);
    this.unitNext.multiply({ x: this.springLength, y: this.springLength });
    this.extensionNext.subtract(this.unitNext);

    Forces.spring(this.restoringPrev, this.kSpring, this.extensionPrev);
    Forces.spring(this.restoringNext, this.kSpring, this.extensionNext);

    Forces.add([this.gravityForce, this.dampingForce, this.restoringPrev, this.restoringNext],this.totalForce);
  }

  updateAccel () {
    this.totalForce.multiply({ x: 1 / this.mass, y: 1 / this.mass });
  }

  updateVelocity (dt) {
    this.vel.add({ x: this.totalForce.x * dt, y: this.totalForce.y * dt });
    this.vel.x = 0;
  }

  move (dt) {
    this.pos.add({ x: this.vel.x * dt, y: this.vel.y * dt });
  }

  checkTooFar (thresholdPoint) {
    const dist = thresholdPoint.y - this.pos.y;
    if (dist > 33) {
      this.pos.y = thresholdPoint.y - 33;
    }
    else if (dist < -33) {
      this.pos.y = thresholdPoint.y + 33;
    }
    this.vel.reset();
  }

  updatePos () {
    this.x = this.pos.x;
    this.y = this.pos.y;
  }

  wave () {
    this.setFrame(UIAssetKeys._Santa_Wave);
    this.unwaveDelay?.remove();
    this.unwaveDelay = this.scene.time.delayedCall(620, this.unwave, null, this);
  }

  unwave () {
    this.setFrame(UIAssetKeys._Santa_Drive);
    this.unwaveDelay = null;
  }
}